import React from 'react';
import "./contact.css";
import Footer from '../common/footer/Footer';
import Hero2 from '../common/hero/Hero2';
import Navbar from '../common/navbar/Navbar';
import ContactComponent from './ContactComponent';
const Contact = () => {
  return (
    <div>
      <Navbar/>
      {/* <Hero2 heading="Contact" text="Let's discuss about your project"/> */}
      <ContactComponent/>
      <Footer/>
    </div>
  )
}

export default Contact;